import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  strategies: [],
  historicalSignalSet: [],
  strategyblacklistSignal: [],
  signals: [],
  loading: false,
  error: null,
};

const strategiesSlice = createSlice({
  name: "strategies",
  initialState,
  reducers: {
    setStrategies: (state, action) => {
      const sortData = action.payload;
      const sort = sortData?.sort((a, b) => (a.name > b.name ? 1 : -1));
      state.strategies = sort;
      state.loading = false;
      state.error = null;
    },
    setBlacklistSignal: (state, action) => {
      state.strategyblacklistSignal = action.payload;
    },  
    addStrategy: (state, action) => {
      if (action.payload?.id) {
        const modifiedPayload = { ...action.payload };
        modifiedPayload.owner = modifiedPayload.owner;
        modifiedPayload.strategyId = modifiedPayload.id;
        modifiedPayload.description = modifiedPayload.description;
        modifiedPayload.date = new Date(modifiedPayload?.date).getTime();
        if (
          !state.strategies.find((a) => a?.strategyId === modifiedPayload.id)
        ) {
          state.strategies = [...state.strategies, modifiedPayload];
          toast.success(`${modifiedPayload.name} has been added successfully.`);
        } else {
          toast.error(`Strategy ${modifiedPayload.name} already exists.`);
        }
      } else {
        toast.error("Failed to add strategy. Please try again.");
      }
      state.loading = false;
      state.error = null;
    },
    updateStrategy: (state, action) => {
      const { id, status, strategy } = action.payload;

      if (status?.toLowerCase() === "success") {
        const existingStrategyIndex = state.strategies?.findIndex(
          (a) => a?.strategyId === id
        );

        if (existingStrategyIndex !== -1) {
          state.strategies[existingStrategyIndex] = strategy;
          toast.success(`${strategy?.name} has been updated successfully`);
        } else {
          toast.error("Strategy not found");
        }
      } else {
        toast.error("Failed to modify strategy. Please try again.");
      }
      state.loading = false;
      state.error = null;
    },
    deleteStrategy: (state, action) => {
      if (action.payload.status.toLowerCase() === "success") {
        const strategyToDelete = state.strategies.find(
          (s) => s?.strategyId === action.payload.id
        );
        state.strategies = state.strategies.filter(
          (a) => a?.strategyId !== action.payload.id
        );
        toast.success(
          `${strategyToDelete?.name} has been deleted successfully`
        );
      } else {
        toast.error("Failed to delete strategy");
      }
      state.loading = false;
      state.error = null;
    },
    setHistoricalSignalSet: (state, action) => {
      state.historicalSignalSet = action.payload;
    },
    updateStrategySignal: (state, action) => {
      const { strategy, weights_keys, weights_values, date } =
        action.payload.data;

      state.strategies = state.strategies.map((a) => {
        if (a.strategyId === strategy) {
          return {
            ...a,
            signals: {
              weights_keys,
              weights_values,
              date,
            },
            date: date,
          };
        }
        return a;
      });
    },
  },
});

export const { 
  setStrategies,
  setBlacklistSignal,
  addStrategy,
  updateStrategy,
  deleteStrategy,
  setHistoricalSignalSet,
  updateStrategySignal
} = strategiesSlice.actions;
export default strategiesSlice.reducer;

// Selectors
export const selectStrategies = (state) => state.strategies.strategies;
export const selectBlacklistSignal = (state) => state.strategies.strategyblacklistSignal;
export const selectHistoricalSignalSet = (state) => state.strategies.historicalSignalSet;
export const selectSignals = (state) => state.strategies.signals;
export const selectStrategiesLoading = (state) => state.strategies.loading;
export const selectStrategiesError = (state) => state.strategies.error;
